// extracted by css-extract-rspack-plugin
export default {"toolbar":"YlYIVRQm_egnIlqd","about":"dLON34m0vbQ1D4dc","createLink":"svmtUAZMmpsTaqJu","summary":"u2Tq4eskTJwb8kya"};